import { CheckIcon } from '../../../components/icons/Icons';

interface WizardStepperProps {
  steps: readonly string[];
  /** Zero-based index of the step currently being edited. */
  currentStep: number;
}

/**
 * The design's step bar: numbered 20px circles, a blue underline for the active
 * step, a green underline plus a tick for completed ones.
 */
export function WizardStepper({ steps, currentStep }: WizardStepperProps) {
  return (
    <div className="wizard-steps">
      {steps.map((label, index) => {
        const state = index < currentStep ? 'done' : index === currentStep ? 'active' : 'todo';
        return (
          <div
            key={label}
            className={`wizard-step ${state === 'done' ? 'wizard-step--done' : ''} ${
              state === 'active' ? 'wizard-step--active' : ''
            }`.trim()}
            aria-current={state === 'active' ? 'step' : undefined}
          >
            <span className={`wizard-step__index wizard-step__index--${state}`}>
              {state === 'done' ? <CheckIcon size={11} /> : index + 1}
            </span>
            <span>{label}</span>
          </div>
        );
      })}
    </div>
  );
}
